export const admin = {
	en: {
		integrations: {
			title: "Integrations",
			options: {
				integrations: {
					title: "Integrations",
				},
				newIntegrations: {
					title: "New integration",
				},
			},
			placeholders: {
				searchbar: "Search a device",
			},
			badges: {
				configured: "Configured",
				unconfigured: "Unconfigured",
			},
			icons: {
				edit: `<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										class="bi bi-pencil-fill"
										viewBox="0 0 16 16"
									>
										<defs>
											<style>
												.a {
													fill: #d9d9d8;
												}
											</style>
										</defs>
										<path
											class="a"
											d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
										/>
									</svg>`,
				delete: `<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										class="bi bi-trash3-fill"
										viewBox="0 0 16 16"
									>
										<defs>
											<style>
												.a {
													fill: #d9d9d8;
												}
											</style>
										</defs>
										<path
											class="a"
											d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"
										/>
									</svg>`,
			},
			modals: {
				deleteModal: {
					title: "Confirmation",
					message:
						"Are you sure you want to delete the integration settings?",
					buttons: {
						close: "Cancel",
						submit: "Accept",
					},
				},
				fleetio: {
					title: "Configuration",
					buttons: {
						validate: "Validate",
						close: "Cancel",
						submit: "Save",
						dropdown: "Select a reference",
						delete: "Delete integrations",
					},
					placeholders: {
						apikey: "API key",
						acount: "Account",
					},
					columns: ["Reference", "Device"],
				},
			},
			errors: {
				validate: "Your API key or Account is invalid",
				saveChanges: "There was an error while saving changes",
				duplicate: "There must not be devices with the same reference",
				emptyArray: "You must set at least one device",
				deleteIntegrationsFailure:
					"There was an error while removing integrations",
				noOptions: "No matches found",
				noMatchesFound: "No matches found",
			},
			notification: {
				validate: "The information is being load",
				saveChanges: "Changes has been saved",
				deleteIntegrationsSuccess: "Integrations successfully removed",
			},
		},
		tooltips: {
			oneToRight: "Move selected items right",
			oneToLeft: "Move selected items left",
			allToRight: "Move all items right",
			allToLeft: "Move all items left",
			engineStop: "Engine Stop",
			speed: "Speed",
			temperature: "Temperature",
			gasConsumption: "Gas consumption",
			drivers: "drivers",
		},
		nav: {
			title: "Administration",
			users: "Users",
			vehicles: "Devices",
			drivers: "Drivers",
			links: "Links",
			alarms: "Alerts",
			roles: "Permissions",
			performance: "Performance",
			groups: "Groups",
			integrations: "Integrations",
		},
		actions: {
			search: "Search",
			save: "Save",
			cancel: "Cancel",
			edit: "Edit",
			del: "Delete",
			yes: "Yes",
			no: "No",
			all: "All",
			columns: "Indicators",
			confirm: "Confirm",
			close: "Close"
		},
		pager: ["Page", "of", "row(s) per page"],
		table: ["No data available in table", "No matching records found"],
		modals: {
			titles: [
				"New User",
				"Edit User",
				"Assign devices",
				"See/Edit Details",
				"New Driver",
				"Edit Driver",
				"New Link",
				"Edit Link",
				"New Permission",
				"Edit Permission",
				"Previous",
				"Next",
				"Delete Permission",
				"Assign Drivers",
				"Delete Alert",
				"Delete user",
				"Delete driver",
				"Delete link",
				"Lock Engine",
				"Unlock Engine",
			],
			tabs: ["Vehicle Details", "Configuration"],
			text: [
				"Do you want to delete _ROLE_ from the list?",
				"Do you want to delete the _ALERT_ from the list?",
				"Do you want to delete _USER_ user from the list?",
				"Do you want to delete _DRIVER_ from the list?",
				"Do you want to delete _LINK_ from the list?",
				"Do you want to lock the device _DEVICE_?",
				"Do you want to unlock the device _DEVICE_?",
			],
		},
		users: {
			title: "Users list",
			new: "New User",
			columns: [
				"Select all",
				"User",
				"Email",
				"Permission",
				"Username",
				"Language",
			],
			forms: {
				name: {
					label: "Name",
					placeholder: "Name",
					required: "Name is required",
				},
				role: {
					label: "Permission",
					placeholder: "Permission",
					required: "Permission is required",
				},
				email: {
					label: "Email",
					placeholder: "Email",
					required: "Email is required",
				},
				username: {
					label: "Username",
					placeholder: "Username",
					required: "Username is required",
				},
				password: {
					label: "Password",
					placeholder: "******",
					required: "Password is required",
				},
				confirm: {
					label: "Confirm Password",
					placeholder: "******",
					required: "Confirm Password is required",
					error: "Passwords do not match",
				},
				language: {
					label: "System Language",
					placeholder: "System Language",
					required: "Language is required",
				},
				avaibles: {
					label: "Available",
					placeholder: "",
					required: "",
				},
				assigned: {
					label: "Assigned",
					placeholder: "",
					required: "",
				},
				language: {
					label: "Language configuration",
					placeholder: "",
					required: "Language is required",
				},
			},
			notifications: {
				create: "_USER_ was created successfully",
				edit: "_USER_ was edited successfully",
				assign: "Devices assigned to _USER_",
				exists: "The username _USER_ is already assigned",
			},
		},
		roles: {
			title: "Permissions list",
			new: "New permission",
			columns: ["Select all", "Permissions"],
			forms: {
				name: {
					label: "Permission name",
					placeholder: "",
					required: "Name is required",
				},
				permissions: {
					label: "Modules",
					placeholder: "Select all",
					required: "You must select at least one module",
				},
				realtime: {
					required: "Required",
				},
			},
			notifications: {
				create: "The permission _ROLE_ was created successfully",
				edit: "The permission _ROLE_ was edited successfully",
			},
		},
		devices: {
			devicesCount: "Device(s)",
			title: "Device list",
			counts: "Without devices | {n} device | {n} devices",
			columns: [
				"Select all",
				"Device",
				"IMEI",
				"Speed Limit",
				"Mileage",
				"Total Engine",
				"Brand",
				"Model",
				"Year",
				"Plates",
				"VIN",
			],
			forms: {
				mileage: {
					label: "Mileage (GPS)",
					placeholder: "",
					required: "Mileage is required",
					help: "Activate to modify the Mileage",
				},
				name: {
					label: "Name",
					placeholder: "",
					required: "Name is required",
				},
				make: {
					label: "Brand",
					placeholder: "",
					required: "Brand is required",
				},
				model: {
					label: "Model",
					placeholder: "",
					required: "Model is required",
				},
				year: {
					label: "Year",
					placeholder: "",
					required: "Year is required",
				},
				plates: {
					label: "Plates",
					placeholder: "",
					required: "Plates is required",
				},
				vinnumber: {
					label: "VIN",
					placeholder: "",
					required: "VIN is required",
				},
				color: {
					label: "Color",
					placeholder: "",
					required: "",
				},
				idleallowed: {
					label: "Maximum IDLE allowed per day (minutes)",
					placeholder: "",
					required: "Maximum IDLE is required",
				},
				starttime: {
					label: "Activity start time",
					placeholder: "",
					required: "Start time is required",
				},
				speedlimit: {
					label: "Speed Threshold (MPH)",
					placeholder: "",
					required: "Speed Threshold is required",
					help: "Post Speed",
				},
				totalengine: {
					label: "Total Engine (hours)",
					placeholder: "Total Engine",
					required: "Total Engine is required",
					help: "Activate to modify Total Engine",
				},
				measurement: {
					label: "Odometer (Miles or Hours)",
					placeholder: "",
					required: "Odometer is required",
				},
				marker: {
					label: "Vehicle icon",
					placeholder: "",
					required: "Vehicle icon is required",
				},
				tag: {
					label: "Label",
					placeholder: "",
					required: "",
					help: "Activate to configure the label",
				},
				fontcolor: {
					label: "Text color",
					placeholder: "",
					required: "Color is required",
					preview: "CAR - 000",
				},
				color: {
					label: "Color",
					placeholder: "",
					required: "Color is required",
				},
				comments: {
					label: "Comments",
					placeholder: "Comments",
					required: "",
				},
			},
			tempconf: {
				title: "Temperature configuration",
				note: "For MIN and MAX type the value and then press ENTER to assign it ",
				columns: ["Notify each", "Min", "Max", "Sensor", "Unit"],
				units: ["Centigrados", "Fahrenheit"],
				unitSelect: "Unidad de medida",
				buttons: {
					cancel: "Cancel",
					save: "Save",
				},
				notifications: {
					success:
						"Temperature configuration was updated successfully",
					warning: "",
					error: "Was an error occurred, please try again",
					errorTemps:
						"Min temperature must be lower than max temperature",
				},
			},
			gasconf: {
				title: "Gas configuration",
				note: "For INCREMENT and DECREMENT enter the percentage value between 0 and 100 and then press ENTER to assign it",
				error: "Only use numbers in the range 0 to 100 to continue.",
				columns: ["Sensor", "Increment", "Decrement"],
				buttons: {
					cancel: "Cancel",
					save: "Save",
				},
				notifications: {
					success: "Fuel settings updated successfully",
					warning: "",
					error: "An error occurred, please try again",
				},
			},
			channels: {
				title: "Video camera assignment to",
				label: "Camera",
				input: "Name",
				labelSelect: 'Select a icon',
				buttons: {
					save: 'Save',
					cancel: 'Cancel'
				}
			},
			notifications: {
				edit: "The device _DEVICE_ was edited successfully",
				assign: "Drivers assigned to device _DEVICE_",
			},
		},
		drivers: {
			title: "Drivers list",
			new: "New driver",
			columns: [
				"Select all",
				"First Name",
				"Last Name",
				"Phone",
				"Employee ID",
				"License",
			],
			forms: {
				firstname: {
					label: "Driver First Name",
					placeholder: "",
					required: "First Name is required",
				},
				lastname: {
					label: "Last Name",
					placeholder: "",
					required: "Last Name is required",
				},
				phone: {
					label: "Phone",
					placeholder: "",
					required: "Phone is required",
				},
				address: {
					label: "Address",
					placeholder: "",
					required: "Address is required",
				},
				id: {
					label: "Employee ID",
					placeholder: "",
					required: "Employee ID is required",
				},
				license: {
					label: "License",
					placeholder: "",
					required: "License is required",
				},
				comments: {
					label: "Comments",
					placeholder: "",
					required: "Comments is required",
				},
				workshift: {
					label: "Workshift",
					placeholder: "",
					required: "Workshift is required",
				},
			},
			notifications: {
				create: "_DRIVER_ was created successfully",
				edit: "_DRIVER_ was edited successfully",
			},
		},
		links: {
			title: "Link History",
			new: "New link",
			columns: [
				"Select all",
				"Title",
				"Devices",
				"Email",
				"Expiration date",
				"Active",
				"Expire in",
			],
			forms: {
				title: {
					label: "Link Title",
					placeholder: "Title example",
					required: "Title is required",
					help: "Must contain minimum of 4 letters",
				},
				description: {
					label: "Description",
					placeholder: "Short description",
					required: "Description is required",
				},
				email: {
					label: "Email",
					placeholder: "example@domain.com",
					required: "Email is required",
					help: "Send the link directly to a person's email",
				},
				device: {
					label: "Select the device",
					placeholder: "",
					required: "Device is required",
				},
				expiredlink: {
					label: "Expiration date",
					placeholder: "",
					required: "Expiración is required",
				},
				datestart: {
					label: "Date start",
					placeholder: "",
					required: "Date start is required",
				},
				duration: {
					label: "Duration (hours)",
					placeholder: "",
					required: "Duration is required",
				},
				avaibles: {
					label: "Avaibles",
					placeholder: "",
					required: "",
				},
				assigned: {
					label: "Assigned",
					placeholder: "",
					required: "",
				},
				language: {
					label: "Language configuration",
					placeholder: "",
					required: "Language is required",
				},
				history: {
					label: "History",
					placeholder: "",
					required: "",
					help: "Allow the user to pull the day's history of the vehicles",
				},
				travel: {
					label: "Show tour",
					placeholder: "",
					required: "",
				},
				hours: {
					label: "History hours",
					placeholder: "",
					required: "",
				},
				desactive: {
					label: "Auto-desactivate",
					placeholder: "Hours to auto-desactivate",
					required: "",
				},
				preload: {
					label: "Preload previous route?",
					placeholder: "",
					required: "",
				},
				message: {
					label: "Custom deactivated message",
					placeholder: "Type your message here",
					required: "",
				},
			},
			notifications: {
				create: "The link _LINK_ was created successfully",
				update: "The link _LINK_ was updated successfully",
				delete: "The link _LINK_ was deleted",
				copy: "The link was copied to clipboard",
				active: "was active/desactive successfully",
			},
		},
		alarms: {
			title: "Alarm notification",
			new: {
				label: "New set",
				options: [
					{
						path: "/alarms/device",
						label: "Devices",
						icon: "vehicle",
					},
					{
						path: "/alarms/geofence",
						label: "Geofences",
						icon: "geofences",
					},
				],
			},
			types: ["Device", "Geofence"],
			columns: [
				"Select all",
				"Name of the set",
				"Type",
				"Email",
				"Main cell",
				"No. of alarms",
			],
			pager: ["Previous", "Next", "Done"],
			steps: [
				{
					title: "Configure your set of alerts",
					note: "Assign a name to your set of alerts and select the type of alert you want for your set.",
				},
				{
					title: "Select devices",
					note: "Select the devices that will carry the set of alerts that you just named.",
				},
				{
					title: "Add an email or cell phone to notify",
					note: "Assign the email or mobile number to which you wish to link to receive notifications from your set of alerts.",
				},
				{
					title: "Configure your set of alerts",
					note: "Assign the name of the set of alerts for geofences, the type of alert (entry or exit) and the schedule of notifications.",
				},
				{
					title: "Select the geofences",
					note: "Select the geofences that will carry the set of alerts you just named.",
				},
				{
					title: "Add an email or cell phone to notify",
					note: "Assign the email or mobile number to which you wish to link to receive notifications from your set of alerts.",
				},
			],
			forms: {
				name: {
					label: "Name of the set",
					placeholder: "Set of alerts for devices 1",
					required: "* Name is required. ",
				},
				alerts: {
					label: "Alerts",
					placeholder: "",
					required: "* You must select at least 1 alert. ",
					help: "Activate all",
				},
				device: {
					label: "Device(s)",
					placeholder: "Select the devices",
					required: "* You must select at least 1 device",
					help: "Select all",
				},
				email: {
					label: "Email and mobile number (SMS) main",
					placeholder: "Email",
					required: "* Email or phone is required",
					help: "",
				},
				phone: {
					placeholder: "Cell phone number (SMS)",
					help: "",
				},
				extras: {
					label: "Additional email or cell number(s)",
					placeholder: "Additional email or cell phone number",
					required: "Invalid email or invalid number (10 digits)",
					help: "",
				},
				name2: {
					label: "Name of the set",
					placeholder: "Set of alerts for geofences 1",
					required: "* Name is required. ",
				},
				alarms: {
					entry: { code: "035", label: "Entry" },
					output: { code: "036", label: "Output" },
					mintime: { code: "037", label: "Minimum time unfulfilled" },
					maxtime: { code: "038", label: "Maximum time exceeded" },
					required: "* You must select at least 1 alert. ",
				},
				schedule: {
					label: "Notification schedule:",
					placeholder: "",
					required: "* Schedule is required. ",
				},
				days: {
					label: "Select days",
					placeholder: "",
					required: "* You must select at least 1 day. ",
				},
				geofences: {
					label: "Geofence(s)",
					placeholder: "Select the geofences",
					required: "* You must select at least 1 geofence",
					help: "Select all",
				},
			},
			notifications: {
				create: "_ALERT_ was created successfully",
				edit: "_ALERT_ was edited successfully",
				delete: "_ALERT_ was deleted",
			},
			config: {
				title: ["Configure alert types", "My alerts"],
				actions: {
					new: "New alert",
					edit: "Edit alert",
					reset: "Restore original settings",
				},
				columns: ["Alias", "Type"],
				forms: {
					alias: {
						label: "Alias",
						placeholder: "Ex. Hours not allowed ",
						required: "* Alias ​​is required.",
					},
					type: {
						label: "Type",
						placeholder: "Select type of alarm",
						required: "* Type is required.",
						allowed: [
							"001",
							"002",
							"003",
							"004",
							"006",
							"007",
							"019",
							"021",
							"025",
							"026",
							"027",
							"028",
							"030",
							"032",
							"200",
							"201",
							"400",
							"997",
							"992",
							"999",
							"-",
							"015",
							"016",
							"-",
							"070",
							"071",
							"080",
							"081",
							"082",
							"-",
							"090",
							"091",
							"092",
							"093",
							"-",
							"1000",
							"1001",
							"1002",
							"1003",
							"1006",
							"1007",
							"1008",
							"1009",
							"1010",
							"1011",
							"1012",
							"1013",
							"1014",
							"1015",
							"1016",
							"1017",
							"1018",
							"1019",
							"1020",
							"1021",
							"1022",
							"1023",
							"1024",
						],
					},
					initial: {
						label: "Start time",
						placeholder: "00:00",
						required: "* Start time is required.",
					},
					final: {
						label: "End time",
						placeholder: "23:59",
						required: "* End time is required.",
					},
					aditional: {
						label: {
							"025": "Length of <b>idle</b>",
							"030": "Length of <b>stop</b>",
							"032": "<b>Overspeed</b> alert",
						},
						appends: ["Minutes", "MPH"],
						placeholder: "0.00 or 00:00",
						required: "",
						help: {
							"025": 'Upon completion; be notified when an idle ends that was longer than the set threshold.<hr class="my-1 border-light">At Threshold; be notified when an idle reached the length indicated, regardless of whether or not the idle has finished.',
							"030": 'Upon completion; be notified when a stop ends that was longer than the set threshold.<hr class="my-1 border-light">At Threshold; be notified when a stop reached the length indicated, regardless of whether or not the stop has finished.',
							"032": "You will be notified when the client goes over their speed threshold plus what you input (ex. If a vehicle’s threshold is 75 and you input 10, you will be notified if a vehicle reaches 85 mph).",
						},
					},
					mode: {
						label: "Mode",
						placeholder: "",
						required: "* Mode is required.",
						options: ["Allowed", "Not allowed"],
					},
					days: {
						label: "Days of activity",
						placeholder: "",
						required: "* You must select at least 1 day. ",
					},
					message: {
						label: "Mail message",
						placeholder: "",
						required: "* Message is required. ",
						help: "The keywords with GS prefix should not be deleted. They can change places. ",
					},
					ended: {
						label: "Notify me",
						options: ["Upon completion", "at Threshold"],
						help: 'Inside only; you will be notified if the event takes place within the selected geofences.<hr class="my-1 border-light">Outside only; you will only be notified if the event takes place outside of the selected geofences.',
					},
					inverted: {
						label: "Geofence notifications",
						options: ["Inside only", "Outside only"],
						help: 'Inside only; you will be notified if the event takes place within the selected geofences.<hr class="my-1 border-light">Outside only; you will only be notified if the event takes place outside of the selected geofences.',
					},
				},
			},
			gasconf: {
				title: "Gas configuration",
				note: "For INCREMENT and DECREMENT type the percentage value between 0 and 100 and then press ENTER to assign it ",
				error: "Use only numbers in the range 0 to 100 to continue",
				columns: ["Sensor", "Increment", "Decrement"],
				buttons: {
					cancel: "Cancel",
					save: "Save",
				},
				notifications: {
					success: "Gas configuration was updated successfully",
					warning: "",
					error: "Was an error occurred, please try again",
				},
			},
			notifications: {
				edit: "The device _DEVICE_ was edited successfully",
				assign: "Drivers assigned to device _DEVICE_",
			},
		},
		drivers: {
			title: "Drivers list",
			new: "New driver",
			columns: [
				"Select all",
				"First Name",
				"Last Name",
				"Phone",
				"Employee ID",
				"License",
			],
			forms: {
				firstname: {
					label: "Driver First Name",
					placeholder: "",
					required: "First Name is required",
				},
				lastname: {
					label: "Last Name",
					placeholder: "",
					required: "Last Name is required",
				},
				phone: {
					label: "Phone",
					placeholder: "",
					required: "Phone is required",
				},
				address: {
					label: "Address",
					placeholder: "",
					required: "Address is required",
				},
				id: {
					label: "Employee ID",
					placeholder: "",
					required: "Employee ID is required",
				},
				license: {
					label: "License",
					placeholder: "",
					required: "License is required",
				},
				comments: {
					label: "Comments",
					placeholder: "",
					required: "Comments is required",
				},
				workshift: {
					label: "Workshift",
					placeholder: "",
					required: "Workshift is required",
				},
			},
			notifications: {
				create: "_DRIVER_ was created successfully",
				edit: "_DRIVER_ was edited successfully",
			},
		},
		links: {
			title: "Link History",
			new: "New link",
			columns: [
				"Select all",
				"Title",
				"Devices",
				"Email",
				"Expiration date",
				"Active",
				"Expire in",
			],
			forms: {
				title: {
					label: "Link Title",
					placeholder: "Title example",
					required: "Title is required",
					help: "Must contain minimum of 4 letters",
				},
				description: {
					label: "Description",
					placeholder: "Short description",
					required: "Description is required",
				},
				email: {
					label: "Email",
					placeholder: "example@domain.com",
					required: "Email is required",
					help: "Send the link directly to a person's email",
				},
				device: {
					label: "Select the device",
					placeholder: "",
					required: "Device is required",
				},
				expiredlink: {
					label: "Expiration date",
					placeholder: "",
					required: "Expiración is required",
				},
				datestart: {
					label: "Date start",
					placeholder: "",
					required: "Date start is required",
				},
				duration: {
					label: "Duration (hours)",
					placeholder: "",
					required: "Duration is required",
				},
				avaibles: {
					label: "Avaibles",
					placeholder: "",
					required: "",
				},
				assigned: {
					label: "Assigned",
					placeholder: "",
					required: "",
				},
				language: {
					label: "Language configuration",
					placeholder: "",
					required: "Language is required",
				},
				history: {
					label: "History",
					placeholder: "",
					required: "",
					help: "Allow the user to pull the day's history of the vehicles",
				},
				travel: {
					label: "Show tour",
					placeholder: "",
					required: "",
				},
				hours: {
					label: "History hours",
					placeholder: "",
					required: "",
				},
				desactive: {
					label: "Auto-desactivate",
					placeholder: "Hours to auto-desactivate",
					required: "",
				},
				preload: {
					label: "Preload previous route?",
					placeholder: "",
					required: "",
				},
				message: {
					label: "Custom deactivated message",
					placeholder: "Type your message here",
					required: "",
				},
			},
			notifications: {
				create: "The link _LINK_ was created successfully",
				update: "The link _LINK_ was updated successfully",
				delete: "The link _LINK_ was deleted",
				copy: "The link was copied to clipboard",
				active: "was active/desactive successfully",
			},
		},
		alarms: {
			title: "Alarm notification",
			new: {
				label: "New set",
				options: [
					{
						path: "/alarms/device",
						label: "Devices",
						icon: "vehicle",
					},
					{
						path: "/alarms/geofence",
						label: "Geofences",
						icon: "geofences",
					},
				],
			},
			types: ["Device", "Geofence"],
			columns: [
				"Select all",
				"Name of the set",
				"Type",
				"Email",
				"Main cell",
				"No. of alarms",
			],
			pager: ["Previous", "Next", "Done"],
			steps: [
				{
					title: "Configure your set of alerts",
					note: "Assign a name to your set of alerts and select the type of alert you want for your set.",
				},
				{
					title: "Select devices",
					note: "Select the devices that will carry the set of alerts that you just named.",
				},
				{
					title: "Add an email or cell phone to notify",
					note: "Assign the email or mobile number to which you wish to link to receive notifications from your set of alerts.",
				},
				{
					title: "Configure your set of alerts",
					note: "Assign the name of the set of alerts for geofences, the type of alert (entry or exit) and the schedule of notifications.",
				},
				{
					title: "Select the geofences",
					note: "Select the geofences that will carry the set of alerts you just named.",
				},
				{
					title: "Add an email or cell phone to notify",
					note: "Assign the email or mobile number to which you wish to link to receive notifications from your set of alerts.",
				},
			],
			forms: {
				name: {
					label: "Name of the set",
					placeholder: "Set of alerts for devices 1",
					required: "* Name is required. ",
				},
				alerts: {
					label: "Alerts",
					placeholder: "",
					required: "* You must select at least 1 alert. ",
					help: "Activate all",
				},
				device: {
					label: "Device(s)",
					placeholder: "Select the devices",
					required: "* You must select at least 1 device",
					help: "Select all",
				},
				email: {
					label: "Email and mobile number (SMS) main",
					placeholder: "Email",
					required: "* Email or phone is required",
					help: "",
				},
				phone: {
					placeholder: "Cell phone number (SMS)",
					help: "",
				},
				extras: {
					label: "Additional email or cell number(s)",
					placeholder: "Additional email or cell phone number",
					required: "Invalid email or invalid number (10 digits)",
					help: "",
				},
				name2: {
					label: "Name of the set",
					placeholder: "Set of alerts for geofences 1",
					required: "* Name is required. ",
				},
				alarms: {
					entry: { code: "035", label: "Entry" },
					output: { code: "036", label: "Output" },
					mintime: { code: "037", label: "Minimum time unfulfilled" },
					maxtime: { code: "038", label: "Maximum time exceeded" },
					required: "* You must select at least 1 alert. ",
				},
				schedule: {
					label: "Notification schedule:",
					placeholder: "",
					required: "* Schedule is required. ",
				},
				days: {
					label: "Select days",
					placeholder: "",
					required: "* You must select at least 1 day. ",
				},
				geofences: {
					label: "Geofence(s)",
					placeholder: "Select the geofences",
					required: "* You must select at least 1 geofence",
					help: "Select all",
				},
			},
			notifications: {
				create: "_ALERT_ was created successfully",
				edit: "_ALERT_ was edited successfully",
				delete: "_ALERT_ was deleted",
			},
			config: {
				title: ["Configure alert types", "My alerts"],
				actions: {
					new: "New alert",
					edit: "Edit alert",
					reset: "Restore original settings",
				},
				columns: ["Alias", "Type"],
				forms: {
					alias: {
						label: "Alias",
						placeholder: "Ex. Hours not allowed ",
						required: "* Alias ​​is required.",
					},
					type: {
						label: "Type",
						placeholder: "Select type of alarm",
						required: "* Type is required.",
						allowed: [
							"001",
							"002",
							"003",
							"004",
							"006",
							"007",
							"019",
							"021",
							"025",
							"026",
							"027",
							"028",
							"030",
							"032",
							"200",
							"201",
							"400",
							"997",
							"999",
							"-",
							"015",
							"016",
							"-",
							"070",
							"071",
							"-",
							"090",
							"091",
							"092",
							"093",
							"-",
							"1000",
							"1001",
							"1002",
							"1003",
							"1006",
							"1007",
							"1008",
							"1009",
							"1010",
							"1011",
							"1012",
							"1013",
							"1014",
							"1015",
							"1016",
							"1017",
							"1018",
							"1019",
							"1020",
							"1021",
							"1022",
							"1023",
							"1024",
						],
					},
					initial: {
						label: "Start time",
						placeholder: "00:00",
						required: "* Start time is required.",
					},
					final: {
						label: "End time",
						placeholder: "23:59",
						required: "* End time is required.",
					},
					aditional: {
						label: {
							"025": "Length of <b>idle</b>",
							"030": "Length of <b>stop</b>",
							"032": "<b>Overspeed</b> alert",
						},
						appends: ["Minutes", "MPH"],
						placeholder: "0.00 or 00:00",
						required: "",
						help: {
							"025": 'Upon completion; be notified when an idle ends that was longer than the set threshold.<hr class="my-1 border-light">At Threshold; be notified when an idle reached the length indicated, regardless of whether or not the idle has finished.',
							"030": 'Upon completion; be notified when a stop ends that was longer than the set threshold.<hr class="my-1 border-light">At Threshold; be notified when a stop reached the length indicated, regardless of whether or not the stop has finished.',
							"032": "You will be notified when the client goes over their speed threshold plus what you input (ex. If a vehicle’s threshold is 75 and you input 10, you will be notified if a vehicle reaches 85 mph).",
						},
					},
					mode: {
						label: "Mode",
						placeholder: "",
						required: "* Mode is required.",
						options: ["Allowed", "Not allowed"],
					},
					days: {
						label: "Days of activity",
						placeholder: "",
						required: "* You must select at least 1 day. ",
					},
					message: {
						label: "Mail message",
						placeholder: "",
						required: "* Message is required. ",
						help: "The keywords with GS prefix should not be deleted. They can change places. ",
					},
					ended: {
						label: "Notify me",
						options: ["Upon completion", "at Threshold"],
						help: 'Inside only; you will be notified if the event takes place within the selected geofences.<hr class="my-1 border-light">Outside only; you will only be notified if the event takes place outside of the selected geofences.',
					},
					inverted: {
						label: "Geofence notifications",
						options: ["Inside only", "Outside only"],
						help: 'Inside only; you will be notified if the event takes place within the selected geofences.<hr class="my-1 border-light">Outside only; you will only be notified if the event takes place outside of the selected geofences.',
					},
				},
			},
			audios: {
				title: "Audio configuration",
				buttons: ["Cancel", "Save"],
				columns: ["Active", "Alert", "Audio", "", "Volume", ""],
				notifications: {
					success: "Configuration saved successfully",
					error: "An error occurred while saving configuration",
					notloaded: "The audio configuration could not be loaded",
				},
			},
		},
		performance: {},
		icons: {
			assign: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 25.466 16.864"><g transform="translate(-54.188 -41.299)"><circle class="a" cx="3.952" cy="3.952" r="3.952" transform="translate(54.188 41.656)"/><path class="b" d="M66.278,49.972h5.787c.081,0,.081.16,0,.16l-3.056.562-2.731-.562C66.2,50.132,66.2,49.972,66.278,49.972ZM79.61,53.424a2.048,2.048,0,0,1-.338,1.262,1.071,1.071,0,0,1,.176.586v1.766a.487.487,0,0,1,0,.054,1.1,1.1,0,0,1-1.124,1.071H78.19a1.1,1.1,0,0,1-1.071-1.125V55.711l-8.03.685H68.93l-.772-.074-7.179-.646v1.362a.487.487,0,0,1,0,.054,1.1,1.1,0,0,1-1.124,1.071h-.134a1.1,1.1,0,0,1-1.071-1.125V55.272c0-.031,0-.063,0-.094a1.094,1.094,0,0,1,.217-.549,2.186,2.186,0,0,1-.38-1.286V50.038a4.514,4.514,0,0,0,.562-.06.428.428,0,0,0,.028.374.253.253,0,0,0,.211.106l4.015.321a.244.244,0,0,0,.076.006.238.238,0,0,0,.19-.106.45.45,0,0,0,.057-.387l-.482-.963c-.079-.079-.161-.16-.241-.16l-1.664-.36a4.455,4.455,0,0,0,1.243-2.2H76.792a.5.5,0,0,0,.453-.263.425.425,0,0,0-.051-.459l-2-3.539a.443.443,0,0,0-.4-.242H63.309a.448.448,0,0,0-.4.241l-.758,1.333a4.459,4.459,0,0,0-.293-.54l.409-.713A2.174,2.174,0,0,1,64.192,41.3h9.555a2.173,2.173,0,0,1,1.928,1.124l1.717,2.926a.2.2,0,0,1,.105-.155,2,2,0,0,1,.316-.161.918.918,0,0,1,.16,0l1.285.08c.16,0,.241.081.316.242l.08.481c0,.161-.08.317-.241.317l-1.365.315,1.16,1.977a2,2,0,0,1,.322,1.124ZM73.666,49.57H64.347L65.476,51.1l3.613.322L72.7,51.1Zm5.372.4-.553-1.281a.319.319,0,0,0-.243-.193h0a.108.108,0,0,0-.079.032l-2.971.723c-.08,0-.161.081-.24.16l-.483.965a.3.3,0,0,0,.033.28.236.236,0,0,0,.288.121l4.015-.321a.253.253,0,0,0,.211-.106A.428.428,0,0,0,79.038,49.968Z"/><path class="c" d="M60.116,45.108H58.64V43.632h-1v1.476H56.164v1H57.64v1.476h1V46.108h1.476Z"/></g></svg>',
			driver: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="18.9" viewBox="0 0 18.896 20.902"><g transform="translate(-1080 -53)"><g transform="translate(1046.5 13)"><path class="a" d="M39.988,53.387c.038-.034.081-.062.118-.1l-.121,0Z"/><path class="a" d="M37.419,46.532a3.919,3.919,0,1,0,0,7.838c.053,0,.1-.013.155-.016a1.356,1.356,0,0,1-.055-1.119l1.723-4.261A1.608,1.608,0,0,1,40.452,48,3.894,3.894,0,0,0,37.419,46.532Z"/><circle class="b" cx="3.672" cy="3.672" r="3.672" transform="translate(41.237 40)"/><path class="b" d="M47.956,57.263H46.845a2.041,2.041,0,0,1-1.323,1.323V60.9a4.307,4.307,0,0,0,3.418-2.77l-.666.109Z"/><path class="b" d="M45.715,56.65a.806.806,0,1,0-.806.807.806.806,0,0,0,.806-.807Z"/><path class="b" d="M44.909,52.356a4.277,4.277,0,0,0-2.971,1.2l1.036.3-.713,2.189h.712a2.031,2.031,0,0,1,3.872,0h.712l-.713-2.189,1.037-.3A4.279,4.279,0,0,0,44.909,52.356Z"/><path class="b" d="M42.973,57.263H41.862l-.318.977-.666-.109A4.308,4.308,0,0,0,44.3,60.9V58.586A2.041,2.041,0,0,1,42.973,57.263Z"/><path class="b" d="M40.267,56.79l.437.072.711-2.183L40.78,54.5l-.761.021-.014-.5a4.373,4.373,0,0,1-2.075.8Z"/><path class="b" d="M52.294,53.235l-1.723-4.261a1.621,1.621,0,0,0-1.51-1.018h-8a4.324,4.324,0,0,1,.28,4.489,5.511,5.511,0,0,1,7.934.832l.559.016L49.8,54.518l-.761-.021-.636.182.711,2.183.437-.072L51.911,54.8A1.369,1.369,0,0,0,52.294,53.235Z"/></g><g transform="translate(1046.5 13)"><circle class="c" cx="3.919" cy="3.919" r="3.919" transform="translate(33.5 46.532)"/></g><path class="d" d="M39.378,49.952H37.919v-1.46h-1v1.46h-1.46v1h1.46v1.459h1V50.952h1.459Z" transform="translate(1046.5 13)"/></g></svg>',
			temp: '<svg xmlns="http://www.w3.org/2000/svg" width="10.11" height="12" viewBox="0 0 10.11 24"><g id="ico_info_temp" transform="translate(-6140.999 -2335)"><path id="Sustracción_1" data-name="Sustracción 1" d="M5.055,24A5.055,5.055,0,0,1,1.65,15.209V3.38a3.379,3.379,0,1,1,6.758,0V15.161A5.056,5.056,0,0,1,5.055,24ZM3.349,7.633V16.06a3.353,3.353,0,1,0,3.413,0V7.633Zm1.706,12.43a1.118,1.118,0,1,1,1.118-1.118A1.119,1.119,0,0,1,5.055,20.063Z" transform="translate(6140.999 2335)" class="b" /></g></svg>',
			channel: '<svg id="camara" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><defs><clipPath id="clip-path"><rect id="Rectángulo_6557" data-name="Rectángulo 6557" width="16" height="16" transform="translate(332 1128)" fill="#999"/></clipPath></defs><g id="eliminar" transform="translate(-332 -1128)" clip-path="url(#clip-path)"><path id="Sustracción_6" data-name="Sustracción 6" d="M-702.25-9895h-3.5a5.255,5.255,0,0,1-5.251-5.248V-9902a5.245,5.245,0,0,1,1.3-3.456,5.253,5.253,0,0,1,3.209-1.741A2.623,2.623,0,0,1-704-9909a2.623,2.623,0,0,1,2.494,1.8,5.252,5.252,0,0,1,3.209,1.741A5.245,5.245,0,0,1-697-9902v1.751A5.255,5.255,0,0,1-702.25-9895Zm-1.75-8.747a2.628,2.628,0,0,0-2.625,2.624A2.628,2.628,0,0,0-704-9898.5a2.628,2.628,0,0,0,2.625-2.625A2.628,2.628,0,0,0-704-9903.747Zm0,3.937a1.314,1.314,0,0,1-1.312-1.312,1.314,1.314,0,0,1,1.312-1.312,1.314,1.314,0,0,1,1.312,1.312A1.314,1.314,0,0,1-704-9899.811Z" transform="translate(1044 11038)" class="b"/></g></svg>'
		},
		engineLock: {
			notifications: {
				confirm: "Command sent successfully.",
				error: "Error sending command.",
				errorGeneral: "An error has occurred.",
			},
		},
		group: {
			title: `Device's Group`,
			columns: ["Name", "Description", "Devices"],
			forms: {
				name: {
					label: "Name",
					placeholder: "Name",
					required: "Name is required",
				},
				description: {
					label: "Description",
					placeholder: "Short description...",
					without: "No description",
				},
			},
			notifications: {
				options: { layout: 2, position: "topCenter" },
				group: {
					empty: "Name is required",
					created: "Group saved successfully",
					deleted: "Group deleted",
					edited: "Group edited successfully",
				},
			},
			modals: {
				new: {
					title: "New group",
				},
				edit: {
					title: "Edit group",
				},
				delete: {
					title: "Delete group",
					message: "Do you want to delete {group} from the list?",
				},
			},
		},
		mobileInfo: {
			title: "Mobile information",
			body: {
				true: 'True',
				false: 'False',
				platform: "Platform",
				versionOS: "Operative System Version",
				isGpsActive: "Is GPS active",
				isAllowedAllTime: "Is allowed all time",
				isActiveAccessNotifications: "Is active access notifications",
				isActiveFineLocation: "Is active fine location",
				isActiveCoarseLocation: "Is active coarse location",
				isActiveReadWriteData: "Is active read and write data",
			}
		}
	},
	es: {
		integrations: {
			title: "Integraciones",
			options: {
				integrations: {
					title: "Integraciones",
				},
				newIntegrations: {
					title: "Nueva integración",
				},
			},
			badges: {
				configured: "Configurado",
				unconfigured: "No configurado",
			},
			placeholders: {
				searchbar: "Busca un dispositivo",
			},
			icons: {
				edit: `<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										class="bi bi-pencil-fill"
										viewBox="0 0 16 16"
									>
										<defs>
											<style>
												.a {
													fill: #d9d9d8;
												}
											</style>
										</defs>
										<path
											class="a"
											d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
										/>
									</svg>`,
				delete: `<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										class="bi bi-trash3-fill"
										viewBox="0 0 16 16"
									>
										<defs>
											<style>
												.a {
													fill: #d9d9d8;
												}
											</style>
										</defs>
										<path
											class="a"
											d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"
										/>
									</svg>`,
			},
			modals: {
				deleteModal: {
					title: "Confirmación",
					message:
						"¿Está seguro de que desea eliminar la configuración de la integración?",
					buttons: {
						close: "Cancelar",
						submit: "Aceptar",
					},
				},
				fleetio: {
					title: "Configuración",
					buttons: {
						validate: "Validar",
						close: "Cancelar",
						submit: "Guardar",
						dropdown: "Selecciona una referencia",
						delete: "Eliminar integraciones",
					},
					placeholders: {
						apikey: "API key",
						acount: "Account",
					},
					columns: ["Referencia", "Dispositivo"],
				},
			},
			errors: {
				validate: "API key o Account inválida",
				saveChanges:
					"Ocurrió un error mientras se guardaban los cambios",
				duplicate:
					"No deben haber dispositivos con la misma referencia",
				emptyArray: "Debe configurar al menos un dispositivo",
				deleteIntegrationsFailure:
					"Ocurrió un error mientras se eliminaban las integraciones",
				noOptions: "No se encontraron coincidencias",
			},
			notification: {
				validate: "La información esta siendo cargada",
				saveChanges: "Se han guardado los cambios",
				deleteIntegrationsSuccess:
					"Integraciones eliminadas correctamente",
			},
		},
		tooltips: {
			oneToRight: "Mover seleccionados a la derecha",
			oneToLeft: "Mover seleccionados a la izquierda",
			allToRight: "Mover todos a la derecha",
			allToLeft: "Mover todos a la izquierda",
			engineStop: "Apagado de motor",
			speed: "Velocidad",
			temperature: "Temperatura",
			gasConsumption: "Consumo de combustible",
			drivers: "Conductores",
		},
		nav: {
			title: "Administración",
			users: "Usuarios",
			vehicles: "Dispositivos",
			drivers: "Conductores",
			links: "Links",
			alarms: "Alarmas",
			roles: "Permisos",
			performance: "Rendimiento",
			groups: "Grupos",
			integrations: "Integraciones",
		},
		actions: {
			search: "Búsqueda",
			save: "Guardar",
			cancel: "Cancelar",
			edit: "Editar",
			del: "Eliminar",
			yes: "Si",
			no: "No",
			all: "Todos",
			columns: "Indicadores",
			confirm: "Confirmar",
			close: 'Cerrar'
		},
		pager: ["Página", "de", "fila(s) por página"],
		table: [
			"No hay datos disponibles en la tabla",
			"No se encontraron registros coincidentes",
		],
		modals: {
			titles: [
				"Nuevo Usuario",
				"Editar Usuario",
				"Asignar vehículos",
				"Ver/Editar Detalles",
				"Nuevo Conductor",
				"Editar Conductor",
				"Nuevo Enlace",
				"Editar Enlace",
				"Nuevo Permiso",
				"Editar Permiso",
				"Anterior",
				"Siguiente",
				"Eliminar Permiso",
				"Asignar Conductores",
				"Eliminar Alerta",
				"Eliminar Usuario",
				"Eliminar Conductor",
				"Eliminar Link",
				"Bloquear Motor",
				"Desbloquear Motor",
				"Información del móvil"
			],
			tabs: ["Unidad", "Configuración"],
			text: [
				"¿Desea eliminar el permiso _ROLE_ de la lista?",
				"¿Desea eliminar la alerta _ALERT_ de la lista?",
				"¿Desea eliminar el usuario _USER_ de la lista?",
				"¿Desea eliminar el conductor _DRIVER_ de la lista?",
				"¿Desea eliminar el link _LINK_ de la lista?",
				"¿Desea bloquear el dispositivo _DEVICE_?",
				"¿Desea desbloquear el dispositivo _DEVICE_?",
			],
		},
		users: {
			title: "Lista de Usuarios",
			new: "Nuevo usuario",
			columns: [
				"Seleccionar todos",
				"Nombre del usuario",
				"Correo electrónico",
				"Permiso",
				"Usuario",
				"Idioma",
			],
			forms: {
				name: {
					label: "Nombre del usuario",
					placeholder: "Nombre",
					required: "Nombre es requerido",
				},
				role: {
					label: "Permiso",
					placeholder: "Permiso",
					required: "Permiso es requerido",
				},
				email: {
					label: "Correo electrónico",
					placeholder: "Correo electrónico",
					required: "Correo electrónico es requerido",
				},
				username: {
					label: "Usuario de acceso",
					placeholder: "Usuario",
					required: "Usuario es requerido",
				},
				password: {
					label: "Contraseña de acceso",
					placeholder: "******",
					required: "Contraseña es requerido",
				},
				confirm: {
					label: "Confirmar contraseña",
					placeholder: "******",
					required: "Confirmar contraseña es requerido",
					error: "Las contraseñas no coinciden",
				},
				language: {
					label: "Idioma del sistema",
					placeholder: "Idioma del sistema",
					required: "Idioma es requerido",
				},
				avaibles: {
					label: "Disponibles",
					placeholder: "",
					required: "",
				},
				assigned: {
					label: "Asignados",
					placeholder: "",
					required: "",
				},
			},
			notifications: {
				create: "_USER_ fue creado exitosamente",
				edit: "_USER_ fue editado exitosamente",
				assign: "Dispositivos asignados a _USER_",
				exists: "El usuario _USER_ ya está asignado",
			},
		},
		roles: {
			title: "Lista de Permisos",
			new: "Nuevo permiso",
			columns: ["Seleccionar todas", "Permisos"],
			forms: {
				name: {
					label: "Nombre del permiso",
					placeholder: "",
					required: "Nombre es requerido",
				},
				permissions: {
					label: "Modulos",
					placeholder: "Seleccionar todas",
					required: "Debe seleccionar al menos un módulo",
				},
				realtime: {
					required: "Requerido",
				},
			},
			notifications: {
				create: "El permiso _ROLE_ fue creado exitosamente",
				edit: "El permiso _ROLE_ fue editado exitosamente",
			},
		},
		devices: {
			devicesCount: "Dispositivo(s)",
			title: "Lista de Dispositivos",
			counts: "Sin dispositivos | {n} dispositivo | {n} dispositivos",
			columns: [
				"Seleccionar todos",
				"Dispositivo",
				"IMEI",
				"Límite de velocidad",
				"Kilometraje Acumulado",
				"Total de encendido",
				"Marca",
				"Modelo",
				"Año",
				"Placas",
				"Serie",
			],
			forms: {
				mileage: {
					label: "Kilometraje Acumulado (GPS)",
					placeholder: "",
					required: "Kilometraje es requerido",
					help: "Activa para modificar el Kilometreje Acumulado",
				},
				name: {
					label: "Nombre",
					placeholder: "",
					required: "Nombre es requerido",
				},
				make: {
					label: "Marca",
					placeholder: "",
					required: "Marca es requerido",
				},
				model: {
					label: "Modelo",
					placeholder: "",
					required: "Modelo es requerido",
				},
				year: {
					label: "Año",
					placeholder: "",
					required: "Año es requerido",
				},
				plates: {
					label: "Placas",
					placeholder: "",
					required: "Placas es requerido",
				},
				vinnumber: {
					label: "Serie",
					placeholder: "",
					required: "Serie es requerido",
				},
				color: {
					label: "Color",
					placeholder: "",
					required: "",
				},
				idleallowed: {
					label: "Máximo IDLE permitido por día (minutos)",
					placeholder: "",
					required: "Máximo IDLE es requerido",
				},
				starttime: {
					label: "Hora de inicio de actividad",
					placeholder: "",
					required: "Hora de inicio es requerido",
				},
				speedlimit: {
					label: "Límite de velocidad (KM)",
					placeholder: "",
					required: "Límite de velocidad es requerido",
					help: "Post Speed",
				},
				totalengine: {
					label: "Total de encendido (horas)",
					placeholder: "Total de encendido",
					required: "Total de encendido es requerido",
					help: "Activar para modificar el Total de encendido",
				},
				measurement: {
					label: "Unidad de medida (Odometro)",
					placeholder: "",
					required: "Unidad de medida es requerido",
				},
				marker: {
					label: "Visualización del vehículo",
					placeholder: "",
					required: "Visualización es requerido",
				},
				tag: {
					label: "Etiqueta",
					placeholder: "",
					required: "",
					help: "Activa para configurar la etiqueta",
				},
				fontcolor: {
					label: "Color del texto",
					placeholder: "",
					required: "Color es requerido",
					preview: "AUTO - 000",
				},
				color: {
					label: "Color del fondo",
					placeholder: "",
					required: "Color del fondo es requerido",
				},
				comments: {
					label: "Comentarios",
					placeholder: "Comentarios",
					required: "",
				},
			},
			tempconf: {
				title: "Configuración de temperatura",
				note: "Para MIN y MAX ingrese el valor y luego presione ENTER para asignarlo",
				columns: ["Notificar cada", "Min", "Max", "Sensor", "Unidad"],
				units: ["Celsius", "Fahrenheit "],
				unitSelect: "Unidad de medida",
				buttons: {
					cancel: "Cancelar",
					save: "Guardar",
				},
				notifications: {
					success:
						"La configuración de temperatura se actualizó correctamente",
					warning: "",
					error: "Se produjo un error, inténtelo de nuevo",
					errorTemps:
						"La temperatura minima debe ser menor a la maxima",
				},
			},
			gasconf: {
				title: "Configuración de combustible",
				note: "Para INCREMENTO y DECREMENTO ingrese el valor porcentual entre 0 y 100 y luego presione ENTER para asignarlo",
				error: "Utiliza unicamente numeros en el rango de 0 a 100 para continuar",
				columns: ["Sensor", "Incremento", "Decremento"],
				buttons: {
					cancel: "Cancelar",
					save: "Guardar",
				},
				notifications: {
					success:
						"La configuración de combustible se actualizó correctamente",
					warning: "",
					error: "Se produjo un error, inténtelo de nuevo",
				},
			},
			channels: {
				title: "Asignación de cámara de video a",
				label: "Cámara",
				input: "Nombre",
				labelSelect: 'Selecciona un icono',
				buttons: {
					save: 'Guardar',
					cancel: 'Cancelar'
				}
			},
			notifications: {
				edit: "El dispositivo _DEVICE_ fue editado exitosamente",
				assign: "Conductores asignados al dispositivo _DEVICE_",
			},
		},
		drivers: {
			title: "Lista de Conductores",
			new: "Nuevo conductor",
			columns: [
				"Seleccionar todos",
				"Nombre",
				"Apellidos",
				"Teléfono",
				"ID Empleado",
				"Licencia",
			],
			forms: {
				firstname: {
					label: "Nombre del conductor",
					placeholder: "",
					required: "Nombre es requerido",
				},
				lastname: {
					label: "Apellidos",
					placeholder: "",
					required: "Apellidos es requerido",
				},
				phone: {
					label: "Teléfono",
					placeholder: "",
					required: "Teléfono es requerido",
				},
				address: {
					label: "Dirección",
					placeholder: "",
					required: "Dirección es requerido",
				},
				id: {
					label: "ID Empleado",
					placeholder: "",
					required: "ID Empleado es requerido",
				},
				license: {
					label: "Licencia",
					placeholder: "",
					required: "Licencia es requerido",
				},
				comments: {
					label: "Comentarios",
					placeholder: "",
					required: "Comentarios es requerido",
				},
				workshift: {
					label: "Turno",
					placeholder: "",
					required: "Turno es requerido",
				},
			},
			notifications: {
				create: "_DRIVER_ fue creado exitosamente",
				edit: "_DRIVER_ fue editado exitosamente",
			},
		},
		links: {
			title: "Histórico de Enlaces",
			new: "Nuevo enlace",
			columns: [
				"Seleccionar todos",
				"Título",
				"Dispositivos",
				"Correo electrónico",
				"Fecha de expiración",
				"Activar",
				"Expira en",
			],
			forms: {
				title: {
					label: "Título del link",
					placeholder: "Ejemplo título",
					required: "Título es requerido",
					help: "Debe contener un mínimo de 4 letras",
				},
				description: {
					label: "Descripción",
					placeholder: "Breve descripción",
					required: "Descripción es requerido",
				},
				email: {
					label: "Correo electrónico",
					placeholder: "ejemplo@dominio.com",
					required: "Correo electrónico es requerido",
					help: "Enviar el enlace directamente al correo electrónico de una persona",
				},
				device: {
					label: "Selecciona el vehículo",
					placeholder: "",
					required: "Vehículo es requerido",
				},
				expiredlink: {
					label: "Fecha de expiración",
					placeholder: "",
					required: "Expiración es requerido",
				},
				datestart: {
					label: "Fecha de inicio",
					placeholder: "YYYY-MM-DD HH:mm",
					required: "Fecha de inicio es requerido",
				},
				duration: {
					label: "Duración (horas)",
					placeholder: "",
					required: "Duración es requerido",
				},
				avaibles: {
					label: "Disponibles",
					placeholder: "",
					required: "",
				},
				assigned: {
					label: "Asignados",
					placeholder: "",
					required: "",
				},
				language: {
					label: "Configuración del idioma",
					placeholder: "",
					required: "Idioma es requerido",
				},
				history: {
					label: "Historial",
					placeholder: "",
					required: "",
					help: "Permitir al usuario extraer el historial del día de los vehículos.",
				},
				travel: {
					label: "Mostrar recorrido",
					placeholder: "",
					required: "",
				},
				hours: {
					label: "Horas del historial",
					placeholder: "",
					required: "",
				},
				desactive: {
					label: "Auto-desactivivar",
					placeholder: "Horas para auto-desactivivar",
					required: "",
				},
				preload: {
					label: "Precargar ruta previa?",
					placeholder: "",
					required: "",
				},
				message: {
					label: "Mensaje personalizado para desactivado",
					placeholder: "Escribe tu mensaje aquí",
					required: "",
				},
			},
			notifications: {
				create: "El enlace _LINK_ fue creado exitosamente",
				update: "El enlace _LINK_ fue editado exitosamente",
				delete: "El enlace _LINK_ fue eliminado",
				copy: "El link fue copiado al portapapeles",
				active: "fue activado/desactivado exitosamente",
			},
		},
		alarms: {
			title: "Notificación de alarmas",
			new: {
				label: "Nuevo Conjunto",
				options: [
					{
						path: "/alarms/device",
						label: "Vehículos",
						icon: "vehicle",
					},
					{
						path: "/alarms/geofence",
						label: "Geocercas",
						icon: "geofences",
					},
				],
			},
			types: ["Vehículo", "Geocerca"],
			columns: [
				"Seleccionar todos",
				"Nombre del conjunto",
				"Tipo",
				"Email",
				"Celular Principal",
				"No. de alarmas",
			],
			pager: ["Anterior", "Siguiente", "Finalizar"],
			steps: [
				{
					title: "Configura tu conjunto de alertas",
					note: "Asigna un nombre a tu conjunto de alertas y selecciona el tipo de alerta que quieres para tu conjunto.",
				},
				{
					title: "Selecciona los vehículos",
					note: "Selecciona los vehículos que llevarán el conjunto de alertas que acabas de nombrar.",
				},
				{
					title: "Agrega un email a notificar",
					note: "Asigna el correo electrónico al que desees vincular para recibir las notificaciones de tu conjunto de alertas.",
				},
				{
					title: "Configura tu conjunto de alertas",
					note: "Asigna el nombre del conjunto de alertas para geocercas, el tipo de alerta (entrada o salida) y el horario de notificaciones.",
				},
				{
					title: "Selecciona las geocercas",
					note: "Selecciona las geocercas que llevarán el conjunto de alertas que acabas de nombrar.",
				},
				{
					title: "Agrega un email a notificar",
					note: "Asigna el correo electrónico al que desees vincular para recibir las notificaciones de tu conjunto de alertas.",
				},
			],
			forms: {
				name: {
					label: "Nombre del conjunto",
					placeholder: "Conjunto de alertas para vehículos 1",
					required: "* Nombre es requerido. ",
				},
				alerts: {
					label: "Alertas",
					placeholder: "",
					required: "* Debe seleccionar al menos 1 alerta. ",
					help: "Activar todas",
				},
				device: {
					label: "Vehículo(s)",
					placeholder: "Selecciona los vehículos",
					required: "* Debe seleccionar al menos 1 vehículo",
					help: "Seleccionar todos",
				},
				email: {
					label: "Correo electrónico principal",
					placeholder: "Correo electrónico",
					required: "* Correo electrónico es requerido",
					help: "",
				},
				phone: {
					placeholder: "numero celular (SMS)",
					help: "",
				},
				extras: {
					label: "Correo electrónico adicional(es)",
					placeholder: "Correo electrónico adicional",
					required: "Correo electrónico invalido",
					help: "",
				},
				name2: {
					label: "Nombre del conjunto",
					placeholder: "Conjunto de alertas para geocerca 1",
					required: "* Nombre es requerido. ",
				},
				alarms: {
					entry: { code: "035", label: "Entrada" },
					output: { code: "036", label: "Salida" },
					mintime: { code: "037", label: "Tiempo mínimo incumplido" },
					maxtime: { code: "038", label: "Tiempo máximo excedido" },
					required: "* Debe seleccionar al menos 1 alerta. ",
				},
				schedule: {
					label: "Horario de notificaciones:",
					placeholder: "",
					required: "* Horario es requerido. ",
				},
				days: {
					label: "Seleccionar días",
					placeholder: "",
					required: "* Debe seleccionar al menos 1 día. ",
				},
				geofences: {
					label: "Geocercas(s)",
					placeholder: "Selecciona las geocercas",
					required: "* Debe seleccionar al menos 1 geocerca",
					help: "Seleccionar todos",
				},
			},
			notifications: {
				create: "La alerta _ALERT_ fue creada exitosamente",
				edit: "La alerta _ALERT_ fue editada exitosamente",
				delete: "La alerta _ALERT_ fue eliminada",
			},
			config: {
				title: ["Configurar tipos de alerta", "Mis alertas"],
				actions: {
					new: "Nueva alerta",
					edit: "Editar alerta",
					reset: "Restaurar configuración original",
				},
				columns: ["Alias", "Tipo"],
				forms: {
					alias: {
						label: "Alias",
						placeholder: "Ej. Horarios no permitidos",
						required: "* Alias es requerido.",
					},
					type: {
						label: "Tipo",
						placeholder: "Seleccionar tipo de alarma",
						required: "* Tipo es requerido.",
						allowed: [
							"001",
							"002",
							"003",
							"004",
							"006",
							"007",
							"019",
							"021",
							"025",
							"026",
							"027",
							"028",
							"030",
							"032",
							"200",
							"201",
							"400",
							"997",
							"999",
							"-",
							"015",
							"016",
							"-",
							"070",
							"071",
							"-",
							"090",
							"091",
							"092",
							"093",
							"-",
							"1000",
							"1001",
							"1002",
							"1003",
							"1006",
							"1007",
							"1008",
							"1009",
							"1010",
							"1011",
							"1012",
							"1013",
							"1014",
							"1015",
							"1016",
							"1017",
							"1018",
							"1019",
							"1020",
							"1021",
							"1022",
							"1023",
							"1024",
						],
					},
					initial: {
						label: "Hora de inicio",
						placeholder: "00:00",
						required: "* Hora de inicio es requerido.",
					},
					final: {
						label: "Hora finalización",
						placeholder: "23:59",
						required: "* Hora finalización es requerido.",
					},
					aditional: {
						label: {
							"025": "Longitud de <b>inactividad</b>",
							"030": "Longitud de <b>parada</b>",
							"032": "Alerta de <b>exceso de velocidad</b>",
						},
						appends: ["Minutos", "KPH"],
						placeholder: "0.00 o 00:00",
						required: "",
						help: {
							"025": 'Al finalizar; recibir una notificación cuando finalice una inactividad superior al umbral establecido. <hr class = "my-1 border-light"> En el umbral; recibir una notificación cuando una inactividad alcance la longitud indicada, independientemente de si la inactividad ha finalizado o no.',
							"030": 'Al finalizar; recibir una notificación cuando finalice una parada que sea más larga que el umbral establecido. <hr class = "my-1 border-light"> En el umbral; recibir una notificación cuando una parada alcance la longitud indicada, independientemente de si la parada ha finalizado o no.',
							"032": "Se le notificará cuando el cliente supere su umbral de velocidad más lo que ingresó (por ejemplo, si el umbral de un vehículo es 75 y usted ingresa 10, se le notificará si un vehículo alcanza 85 mph)",
						},
					},
					mode: {
						label: "Modo",
						placeholder: "",
						required: "* Modo es requerido.",
						options: ["Permitido", "No permitido"],
					},
					days: {
						label: "Días de actividad",
						placeholder: "",
						required: "* Debe seleccionar al menos 1 día. ",
					},
					message: {
						label: "Mensaje de correo",
						placeholder: "",
						required: "* Mensaje es requerido. ",
						help: "Las palabras claves con prefijo GS no deben ser borradas. Pueden cambiarse de lugar.",
					},
					ended: {
						label: "Notificarme",
						options: ["Al finalizar", "en el umbral"],
						help: 'Solo adentro; se le notificará si el evento tiene lugar dentro de las geofences seleccionadas. <hr class = "my-1 border-light"> Solo afuera; solo se le notificará si el evento se lleva a cabo fuera de las geocercas seleccionadas.',
					},
					inverted: {
						label: "Notificaciones de geocercas",
						options: ["Solo adentro", "Solo afuera"],
						help: 'Solo adentro; se le notificará si el evento tiene lugar dentro de las geofences seleccionadas. <hr class = "my-1 border-light"> Solo afuera; solo se le notificará si el evento se lleva a cabo fuera de las geocercas seleccionadas.',
					},
				},
			},
			audios: {
				title: "Configuración de audios",
				buttons: ["Cancelar", "Guardar"],
				columns: ["Activo", "Alerta", "Audio", "", "Volumen", ""],
				notifications: {
					success: "Configuración guardada con éxito",
					error: "Ha ocurrido un error al guardar configuración",
					notloaded:
						"No se ha podido cargar la configuración de audios",
				},
			},
		},
		performance: {
			title: "Rendimiento",
			columns: [
				"Dispositivo",
				"Fecha",
				"Litros A.M.",
				"Litros P.M.",
				"Costo por litro",
				"KM Día",
				"KM Total",
				"KM/Litro",
				"Costo Total",
			],
			modal: {
				title: "Configuración de combustible",
				columns: ["Combustible", "Costo"],
			},
			forms: {
				name: {
					label: "Nombre del combustible",
					placeholder: "Ej. Magna",
					required: "Nombre es requerido",
					help: "",
				},
				cost: {
					label: "Costo por litro",
					placeholder: "Ej. 19.20",
					required: "Costo es requerido",
					help: "",
				},
			},
			notifications: {
				create: "El combustible _FUEL_ fue creado exitosamente",
				delete: "El combustible _FUEL_ fue eliminado",
			},
		},
		icons: {
			assign: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 25.466 16.864"><g transform="translate(-54.188 -41.299)"><circle class="a" cx="3.952" cy="3.952" r="3.952" transform="translate(54.188 41.656)"/><path class="b" d="M66.278,49.972h5.787c.081,0,.081.16,0,.16l-3.056.562-2.731-.562C66.2,50.132,66.2,49.972,66.278,49.972ZM79.61,53.424a2.048,2.048,0,0,1-.338,1.262,1.071,1.071,0,0,1,.176.586v1.766a.487.487,0,0,1,0,.054,1.1,1.1,0,0,1-1.124,1.071H78.19a1.1,1.1,0,0,1-1.071-1.125V55.711l-8.03.685H68.93l-.772-.074-7.179-.646v1.362a.487.487,0,0,1,0,.054,1.1,1.1,0,0,1-1.124,1.071h-.134a1.1,1.1,0,0,1-1.071-1.125V55.272c0-.031,0-.063,0-.094a1.094,1.094,0,0,1,.217-.549,2.186,2.186,0,0,1-.38-1.286V50.038a4.514,4.514,0,0,0,.562-.06.428.428,0,0,0,.028.374.253.253,0,0,0,.211.106l4.015.321a.244.244,0,0,0,.076.006.238.238,0,0,0,.19-.106.45.45,0,0,0,.057-.387l-.482-.963c-.079-.079-.161-.16-.241-.16l-1.664-.36a4.455,4.455,0,0,0,1.243-2.2H76.792a.5.5,0,0,0,.453-.263.425.425,0,0,0-.051-.459l-2-3.539a.443.443,0,0,0-.4-.242H63.309a.448.448,0,0,0-.4.241l-.758,1.333a4.459,4.459,0,0,0-.293-.54l.409-.713A2.174,2.174,0,0,1,64.192,41.3h9.555a2.173,2.173,0,0,1,1.928,1.124l1.717,2.926a.2.2,0,0,1,.105-.155,2,2,0,0,1,.316-.161.918.918,0,0,1,.16,0l1.285.08c.16,0,.241.081.316.242l.08.481c0,.161-.08.317-.241.317l-1.365.315,1.16,1.977a2,2,0,0,1,.322,1.124ZM73.666,49.57H64.347L65.476,51.1l3.613.322L72.7,51.1Zm5.372.4-.553-1.281a.319.319,0,0,0-.243-.193h0a.108.108,0,0,0-.079.032l-2.971.723c-.08,0-.161.081-.24.16l-.483.965a.3.3,0,0,0,.033.28.236.236,0,0,0,.288.121l4.015-.321a.253.253,0,0,0,.211-.106A.428.428,0,0,0,79.038,49.968Z"/><path class="c" d="M60.116,45.108H58.64V43.632h-1v1.476H56.164v1H57.64v1.476h1V46.108h1.476Z"/></g></svg>',
			driver: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="18.9" viewBox="0 0 18.896 20.902"><g transform="translate(-1080 -53)"><g transform="translate(1046.5 13)"><path class="a" d="M39.988,53.387c.038-.034.081-.062.118-.1l-.121,0Z"/><path class="a" d="M37.419,46.532a3.919,3.919,0,1,0,0,7.838c.053,0,.1-.013.155-.016a1.356,1.356,0,0,1-.055-1.119l1.723-4.261A1.608,1.608,0,0,1,40.452,48,3.894,3.894,0,0,0,37.419,46.532Z"/><circle class="b" cx="3.672" cy="3.672" r="3.672" transform="translate(41.237 40)"/><path class="b" d="M47.956,57.263H46.845a2.041,2.041,0,0,1-1.323,1.323V60.9a4.307,4.307,0,0,0,3.418-2.77l-.666.109Z"/><path class="b" d="M45.715,56.65a.806.806,0,1,0-.806.807.806.806,0,0,0,.806-.807Z"/><path class="b" d="M44.909,52.356a4.277,4.277,0,0,0-2.971,1.2l1.036.3-.713,2.189h.712a2.031,2.031,0,0,1,3.872,0h.712l-.713-2.189,1.037-.3A4.279,4.279,0,0,0,44.909,52.356Z"/><path class="b" d="M42.973,57.263H41.862l-.318.977-.666-.109A4.308,4.308,0,0,0,44.3,60.9V58.586A2.041,2.041,0,0,1,42.973,57.263Z"/><path class="b" d="M40.267,56.79l.437.072.711-2.183L40.78,54.5l-.761.021-.014-.5a4.373,4.373,0,0,1-2.075.8Z"/><path class="b" d="M52.294,53.235l-1.723-4.261a1.621,1.621,0,0,0-1.51-1.018h-8a4.324,4.324,0,0,1,.28,4.489,5.511,5.511,0,0,1,7.934.832l.559.016L49.8,54.518l-.761-.021-.636.182.711,2.183.437-.072L51.911,54.8A1.369,1.369,0,0,0,52.294,53.235Z"/></g><g transform="translate(1046.5 13)"><circle class="c" cx="3.919" cy="3.919" r="3.919" transform="translate(33.5 46.532)"/></g><path class="d" d="M39.378,49.952H37.919v-1.46h-1v1.46h-1.46v1h1.46v1.459h1V50.952h1.459Z" transform="translate(1046.5 13)"/></g></svg>',
			temp: '<svg xmlns="http://www.w3.org/2000/svg" width="10.11" height="12" viewBox="0 0 10.11 24"><g id="ico_info_temp" transform="translate(-6140.999 -2335)"><path id="Sustracción_1" data-name="Sustracción 1" d="M5.055,24A5.055,5.055,0,0,1,1.65,15.209V3.38a3.379,3.379,0,1,1,6.758,0V15.161A5.056,5.056,0,0,1,5.055,24ZM3.349,7.633V16.06a3.353,3.353,0,1,0,3.413,0V7.633Zm1.706,12.43a1.118,1.118,0,1,1,1.118-1.118A1.119,1.119,0,0,1,5.055,20.063Z" transform="translate(6140.999 2335)" class="b" /></g></svg>',
			channel: '<svg id="camara" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><defs><clipPath id="clip-path"><rect id="Rectángulo_6557" data-name="Rectángulo 6557" width="16" height="16" transform="translate(332 1128)" fill="#999"/></clipPath></defs><g id="eliminar" transform="translate(-332 -1128)" clip-path="url(#clip-path)"><path id="Sustracción_6" data-name="Sustracción 6" d="M-702.25-9895h-3.5a5.255,5.255,0,0,1-5.251-5.248V-9902a5.245,5.245,0,0,1,1.3-3.456,5.253,5.253,0,0,1,3.209-1.741A2.623,2.623,0,0,1-704-9909a2.623,2.623,0,0,1,2.494,1.8,5.252,5.252,0,0,1,3.209,1.741A5.245,5.245,0,0,1-697-9902v1.751A5.255,5.255,0,0,1-702.25-9895Zm-1.75-8.747a2.628,2.628,0,0,0-2.625,2.624A2.628,2.628,0,0,0-704-9898.5a2.628,2.628,0,0,0,2.625-2.625A2.628,2.628,0,0,0-704-9903.747Zm0,3.937a1.314,1.314,0,0,1-1.312-1.312,1.314,1.314,0,0,1,1.312-1.312,1.314,1.314,0,0,1,1.312,1.312A1.314,1.314,0,0,1-704-9899.811Z" transform="translate(1044 11038)" class="b"/></g></svg>'
		},
		engineLock: {
			notifications: {
				confirm: "Comando enviado correctamente.",
				error: "Ha ocurrido un error al enviar el comando.",
				errorGeneral: "Ha ocurrido un error, intente de nuevo.",
			},
		},
		group: {
			title: "Lista de grupos",
			columns: ["Nombre", "Descripción", "Dispositivos"],
			forms: {
				name: {
					label: "Nombre",
					placeholder: "Nombre",
					required: "Nombre is required",
				},
				description: {
					label: "Descripción",
					placeholder: "Descripción corta...",
				},
			},
			notifications: {
				edit: "El dispositivo _DEVICE_ fue editado exitosamente",
				assign: "Conductores asignados al dispositivo _DEVICE_",
			},
		},
		drivers: {
			title: "Lista de Conductores",
			new: "Nuevo conductor",
			columns: [
				"Seleccionar todos",
				"Nombre",
				"Apellidos",
				"Teléfono",
				"ID Empleado",
				"Licencia",
			],
			forms: {
				firstname: {
					label: "Nombre del conductor",
					placeholder: "",
					required: "Nombre es requerido",
				},
				lastname: {
					label: "Apellidos",
					placeholder: "",
					required: "Apellidos es requerido",
				},
				phone: {
					label: "Teléfono",
					placeholder: "",
					required: "Teléfono es requerido",
				},
				address: {
					label: "Dirección",
					placeholder: "",
					required: "Dirección es requerido",
				},
				id: {
					label: "ID Empleado",
					placeholder: "",
					required: "ID Empleado es requerido",
				},
				license: {
					label: "Licencia",
					placeholder: "",
					required: "Licencia es requerido",
				},
				comments: {
					label: "Comentarios",
					placeholder: "",
					required: "Comentarios es requerido",
				},
				workshift: {
					label: "Turno",
					placeholder: "",
					required: "Turno es requerido",
				},
			},
			notifications: {
				create: "_DRIVER_ fue creado exitosamente",
				edit: "_DRIVER_ fue editado exitosamente",
			},
		},
		links: {
			title: "Historico de Enlaces",
			new: "Nuevo enlace",
			columns: [
				"Seleccionar todos",
				"Título",
				"Dispositivos",
				"Correo electrónico",
				"Fecha de expiración",
				"Activar",
				"Expira en",
			],
			forms: {
				title: {
					label: "Título del link",
					placeholder: "Ejemplo título",
					required: "Título es requerido",
					help: "Debe contener un mínimo de 4 letras",
				},
				description: {
					label: "Descripción",
					placeholder: "Breve descripción",
					required: "Descripción es requerido",
				},
				email: {
					label: "Correo electrónico",
					placeholder: "ejemplo@dominio.com",
					required: "Correo electrónico es requerido",
					help: "Enviar el enlace directamente al correo electrónico de una persona",
				},
				device: {
					label: "Selecciona el vehículo",
					placeholder: "",
					required: "Vehículo es requerido",
				},
				expiredlink: {
					label: "Fecha de expiración",
					placeholder: "",
					required: "Expiración es requerido",
				},
				datestart: {
					label: "Fecha de inicio",
					placeholder: "YYYY-MM-DD HH:mm",
					required: "Fecha de inicio es requerido",
				},
				duration: {
					label: "Duración (horas)",
					placeholder: "",
					required: "Duración es requerido",
				},
				avaibles: {
					label: "Disponibles",
					placeholder: "",
					required: "",
				},
				assigned: {
					label: "Asignados",
					placeholder: "",
					required: "",
				},
				language: {
					label: "Configuración del idioma",
					placeholder: "",
					required: "Idioma es requerido",
				},
				history: {
					label: "Historial",
					placeholder: "",
					required: "",
					help: "Permitir al usuario extraer el historial del día de los vehículos.",
				},
				travel: {
					label: "Mostrar recorrido",
					placeholder: "",
					required: "",
				},
				hours: {
					label: "Horas del historial",
					placeholder: "",
					required: "",
				},
				desactive: {
					label: "Auto-desactivivar",
					placeholder: "Horas para auto-desactivivar",
					required: "",
				},
				preload: {
					label: "Precargar ruta previa?",
					placeholder: "",
					required: "",
				},
				message: {
					label: "Mensaje personalizado para desactivado",
					placeholder: "Escribe tu mensaje aquí",
					required: "",
				},
			},
			notifications: {
				create: "El enlace _LINK_ fue creado exitosamente",
				update: "El enlace _LINK_ fue editado exitosamente",
				delete: "El enlace _LINK_ fue eliminado",
				copy: "El link fue copiado al portapapeles",
				active: "fue activado/desactivado exitosamente",
			},
		},
		alarms: {
			title: "Notificación de alarmas",
			new: {
				label: "Nuevo Conjunto",
				options: [
					{
						path: "/alarms/device",
						label: "Vehículos",
						icon: "vehicle",
					},
					{
						path: "/alarms/geofence",
						label: "Geocercas",
						icon: "geofences",
					},
				],
			},
			types: ["Vehículo", "Geocerca"],
			columns: [
				"Seleccionar todos",
				"Nombre del conjunto",
				"Tipo",
				"Email",
				"Celular principal",
				"No. de alarmas",
			],
			pager: ["Anterior", "Siguiente", "Finalizar"],
			steps: [
				{
					title: "Configura tu conjunto de alertas",
					note: "Asigna un nombre a tu conjunto de alertas y selecciona el tipo de alerta que quieres para tu conjunto.",
				},
				{
					title: "Selecciona los vehículos",
					note: "Selecciona los vehículos que llevarán el conjunto de alertas que acabas de nombrar.",
				},
				{
					title: "Agrega un email a notificar",
					note: "Asigna el correo electrónico al que desees vincular para recibir las notificaciones de tu conjunto de alertas.",
				},
				{
					title: "Configura tu conjunto de alertas",
					note: "Asigna el nombre del conjunto de alertas para geocercas, el tipo de alerta (entrada o salida) y el horario de notificaciones.",
				},
				{
					title: "Selecciona las geocercas",
					note: "Selecciona las geocercas que llevarán el conjunto de alertas que acabas de nombrar.",
				},
				{
					title: "Agrega un email a notificar",
					note: "Asigna el correo electrónico al que desees vincular para recibir las notificaciones de tu conjunto de alertas.",
				},
			],
			forms: {
				name: {
					label: "Nombre del conjunto",
					placeholder: "Conjunto de alertas para vehículos 1",
					required: "* Nombre es requerido. ",
				},
				alerts: {
					label: "Alertas",
					placeholder: "",
					required: "* Debe seleccionar al menos 1 alerta. ",
					help: "Activar todas",
				},
				device: {
					label: "Vehículo(s)",
					placeholder: "Selecciona los vehículos",
					required: "* Debe seleccionar al menos 1 vehículo",
					help: "Seleccionar todos",
				},
				email: {
					label: "Correo electrónico principal",
					placeholder: "Correo electrónico",
					required: "* Correo electrónico es requerido",
					help: "",
				},
				phone: {
					placeholder: "numero celular (SMS)",
					help: "",
				},
				extras: {
					label: "Correo electrónico adicional(es)",
					placeholder: "Correo electrónico adicional",
					required: "Correo electrónico invalido",
					help: "",
				},
				name2: {
					label: "Nombre del conjunto",
					placeholder: "Conjunto de alertas para geocerca 1",
					required: "* Nombre es requerido. ",
				},
				alarms: {
					entry: { code: "035", label: "Entrada" },
					output: { code: "036", label: "Salida" },
					mintime: { code: "037", label: "Tiempo mínimo incumplido" },
					maxtime: { code: "038", label: "Tiempo máximo excedido" },
					required: "* Debe seleccionar al menos 1 alerta. ",
				},
				schedule: {
					label: "Horario de notificaciones:",
					placeholder: "",
					required: "* Horario es requerido. ",
				},
				days: {
					label: "Seleccionar días",
					placeholder: "",
					required: "* Debe seleccionar al menos 1 día. ",
				},
				geofences: {
					label: "Geocercas(s)",
					placeholder: "Selecciona las geocercas",
					required: "* Debe seleccionar al menos 1 geocerca",
					help: "Seleccionar todos",
				},
			},
			notifications: {
				create: "La alerta _ALERT_ fue creada exitosamente",
				edit: "La alerta _ALERT_ fue editada exitosamente",
				delete: "La alerta _ALERT_ fue eliminada",
			},
			config: {
				title: ["Configurar tipos de alerta", "Mis alertas"],
				actions: {
					new: "Nueva alerta",
					edit: "Editar alerta",
					reset: "Restaurar configuración original",
				},
				columns: ["Alias", "Tipo"],
				forms: {
					alias: {
						label: "Alias",
						placeholder: "Ej. Horarios no permitidos",
						required: "* Alias es requerido.",
					},
					type: {
						label: "Tipo",
						placeholder: "Seleccionar tipo de alarma",
						required: "* Tipo es requerido.",
						allowed: [
							"001",
							"002",
							"003",
							"004",
							"006",
							"007",
							"019",
							"021",
							"025",
							"026",
							"027",
							"028",
							"030",
							"032",
							"200",
							"201",
							"400",
							"997",
							"992",
							"999",
							"-",
							"015",
							"016",
							"-",
							"070",
							"071",
							"080",
							"081",
							"082",
							"-",
							"090",
							"091",
							"092",
							"093",
							"-",
							"1000",
							"1001",
							"1002",
							"1003",
							"1006",
							"1007",
							"1008",
							"1009",
							"1010",
							"1011",
							"1012",
							"1013",
							"1014",
							"1015",
							"1016",
							"1017",
							"1018",
							"1019",
							"1020",
							"1021",
							"1022",
							"1023",
							"1024",
						],
					},
					initial: {
						label: "Hora de inicio",
						placeholder: "00:00",
						required: "* Hora de inicio es requerido.",
					},
					final: {
						label: "Hora finalización",
						placeholder: "23:59",
						required: "* Hora finalización es requerido.",
					},
					aditional: {
						label: {
							"025": "Longitud de <b>inactividad</b>",
							"030": "Longitud de <b>parada</b>",
							"032": "Alerta de <b>exceso de velocidad</b>",
						},
						appends: ["Minutos", "KPH"],
						placeholder: "0.00 o 00:00",
						required: "",
						help: {
							"025": 'Al finalizar; recibir una notificación cuando finalice una inactividad superior al umbral establecido. <hr class = "my-1 border-light"> En el umbral; recibir una notificación cuando una inactividad alcance la longitud indicada, independientemente de si la inactividad ha finalizado o no.',
							"030": 'Al finalizar; recibir una notificación cuando finalice una parada que sea más larga que el umbral establecido. <hr class = "my-1 border-light"> En el umbral; recibir una notificación cuando una parada alcance la longitud indicada, independientemente de si la parada ha finalizado o no.',
							"032": "Se le notificará cuando el cliente supere su umbral de velocidad más lo que ingresó (por ejemplo, si el umbral de un vehículo es 75 y usted ingresa 10, se le notificará si un vehículo alcanza 85 mph)",
						},
					},
					mode: {
						label: "Modo",
						placeholder: "",
						required: "* Modo es requerido.",
						options: ["Permitido", "No permitido"],
					},
					days: {
						label: "Días de actividad",
						placeholder: "",
						required: "* Debe seleccionar al menos 1 día. ",
					},
					message: {
						label: "Mensaje de correo",
						placeholder: "",
						required: "* Mensaje es requerido. ",
						help: "Las palabras claves con prefijo GS no deben ser borradas. Pueden cambiarse de lugar.",
					},
					ended: {
						label: "Notificarme",
						options: ["Al finalizar", "en el umbral"],
						help: 'Solo adentro; se le notificará si el evento tiene lugar dentro de las geofences seleccionadas. <hr class = "my-1 border-light"> Solo afuera; solo se le notificará si el evento se lleva a cabo fuera de las geocercas seleccionadas.',
					},
					inverted: {
						label: "Notificaciones de geocercas",
						options: ["Solo adentro", "Solo afuera"],
						help: 'Solo adentro; se le notificará si el evento tiene lugar dentro de las geofences seleccionadas. <hr class = "my-1 border-light"> Solo afuera; solo se le notificará si el evento se lleva a cabo fuera de las geocercas seleccionadas.',
					},
				},
			},
			audios: {
				title: "Configuración de audios",
				buttons: ["Cancelar", "Guardar"],
				columns: ["Activo", "Alerta", "Audio", "", "Volumen", ""],
				notifications: {
					success: "Configuración guardada con éxito",
					error: "Ha ocurrido un error al guardar configuración",
					notloaded:
						"No se ha podido cargar la configuración de audios",
				},
			},
		},
		performance: {
			title: "Rendimiento",
			columns: [
				"Dispositivo",
				"Fecha",
				"Litros A.M.",
				"Litros P.M.",
				"Costo por litro",
				"KM Día",
				"KM Total",
				"KM/Litro",
				"Costo Total",
			],
			modal: {
				title: "Configuración de combustible",
				columns: ["Combustible", "Costo"],
			},
			forms: {
				name: {
					label: "Nombre del combustible",
					placeholder: "Ej. Magna",
					required: "Nombre es requerido",
					help: "",
				},
				cost: {
					label: "Costo por litro",
					placeholder: "Ej. 19.20",
					required: "Costo es requerido",
					help: "",
				},
			},
			notifications: {
				create: "El combustible _FUEL_ fue creado exitosamente",
				delete: "El combustible _FUEL_ fue eliminado",
			},
		},
		// icons: {
		// 	assign: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 25.466 16.864"><g transform="translate(-54.188 -41.299)"><circle class="a" cx="3.952" cy="3.952" r="3.952" transform="translate(54.188 41.656)"/><path class="b" d="M66.278,49.972h5.787c.081,0,.081.16,0,.16l-3.056.562-2.731-.562C66.2,50.132,66.2,49.972,66.278,49.972ZM79.61,53.424a2.048,2.048,0,0,1-.338,1.262,1.071,1.071,0,0,1,.176.586v1.766a.487.487,0,0,1,0,.054,1.1,1.1,0,0,1-1.124,1.071H78.19a1.1,1.1,0,0,1-1.071-1.125V55.711l-8.03.685H68.93l-.772-.074-7.179-.646v1.362a.487.487,0,0,1,0,.054,1.1,1.1,0,0,1-1.124,1.071h-.134a1.1,1.1,0,0,1-1.071-1.125V55.272c0-.031,0-.063,0-.094a1.094,1.094,0,0,1,.217-.549,2.186,2.186,0,0,1-.38-1.286V50.038a4.514,4.514,0,0,0,.562-.06.428.428,0,0,0,.028.374.253.253,0,0,0,.211.106l4.015.321a.244.244,0,0,0,.076.006.238.238,0,0,0,.19-.106.45.45,0,0,0,.057-.387l-.482-.963c-.079-.079-.161-.16-.241-.16l-1.664-.36a4.455,4.455,0,0,0,1.243-2.2H76.792a.5.5,0,0,0,.453-.263.425.425,0,0,0-.051-.459l-2-3.539a.443.443,0,0,0-.4-.242H63.309a.448.448,0,0,0-.4.241l-.758,1.333a4.459,4.459,0,0,0-.293-.54l.409-.713A2.174,2.174,0,0,1,64.192,41.3h9.555a2.173,2.173,0,0,1,1.928,1.124l1.717,2.926a.2.2,0,0,1,.105-.155,2,2,0,0,1,.316-.161.918.918,0,0,1,.16,0l1.285.08c.16,0,.241.081.316.242l.08.481c0,.161-.08.317-.241.317l-1.365.315,1.16,1.977a2,2,0,0,1,.322,1.124ZM73.666,49.57H64.347L65.476,51.1l3.613.322L72.7,51.1Zm5.372.4-.553-1.281a.319.319,0,0,0-.243-.193h0a.108.108,0,0,0-.079.032l-2.971.723c-.08,0-.161.081-.24.16l-.483.965a.3.3,0,0,0,.033.28.236.236,0,0,0,.288.121l4.015-.321a.253.253,0,0,0,.211-.106A.428.428,0,0,0,79.038,49.968Z"/><path class="c" d="M60.116,45.108H58.64V43.632h-1v1.476H56.164v1H57.64v1.476h1V46.108h1.476Z"/></g></svg>',
		// 	driver: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="18.9" viewBox="0 0 18.896 20.902"><g transform="translate(-1080 -53)"><g transform="translate(1046.5 13)"><path class="a" d="M39.988,53.387c.038-.034.081-.062.118-.1l-.121,0Z"/><path class="a" d="M37.419,46.532a3.919,3.919,0,1,0,0,7.838c.053,0,.1-.013.155-.016a1.356,1.356,0,0,1-.055-1.119l1.723-4.261A1.608,1.608,0,0,1,40.452,48,3.894,3.894,0,0,0,37.419,46.532Z"/><circle class="b" cx="3.672" cy="3.672" r="3.672" transform="translate(41.237 40)"/><path class="b" d="M47.956,57.263H46.845a2.041,2.041,0,0,1-1.323,1.323V60.9a4.307,4.307,0,0,0,3.418-2.77l-.666.109Z"/><path class="b" d="M45.715,56.65a.806.806,0,1,0-.806.807.806.806,0,0,0,.806-.807Z"/><path class="b" d="M44.909,52.356a4.277,4.277,0,0,0-2.971,1.2l1.036.3-.713,2.189h.712a2.031,2.031,0,0,1,3.872,0h.712l-.713-2.189,1.037-.3A4.279,4.279,0,0,0,44.909,52.356Z"/><path class="b" d="M42.973,57.263H41.862l-.318.977-.666-.109A4.308,4.308,0,0,0,44.3,60.9V58.586A2.041,2.041,0,0,1,42.973,57.263Z"/><path class="b" d="M40.267,56.79l.437.072.711-2.183L40.78,54.5l-.761.021-.014-.5a4.373,4.373,0,0,1-2.075.8Z"/><path class="b" d="M52.294,53.235l-1.723-4.261a1.621,1.621,0,0,0-1.51-1.018h-8a4.324,4.324,0,0,1,.28,4.489,5.511,5.511,0,0,1,7.934.832l.559.016L49.8,54.518l-.761-.021-.636.182.711,2.183.437-.072L51.911,54.8A1.369,1.369,0,0,0,52.294,53.235Z"/></g><g transform="translate(1046.5 13)"><circle class="c" cx="3.919" cy="3.919" r="3.919" transform="translate(33.5 46.532)"/></g><path class="d" d="M39.378,49.952H37.919v-1.46h-1v1.46h-1.46v1h1.46v1.459h1V50.952h1.459Z" transform="translate(1046.5 13)"/></g></svg>',
		// 	temp: '<svg xmlns="http://www.w3.org/2000/svg" width="10.11" height="12" viewBox="0 0 10.11 24"><g id="ico_info_temp" transform="translate(-6140.999 -2335)"><path id="Sustracción_1" data-name="Sustracción 1" d="M5.055,24A5.055,5.055,0,0,1,1.65,15.209V3.38a3.379,3.379,0,1,1,6.758,0V15.161A5.056,5.056,0,0,1,5.055,24ZM3.349,7.633V16.06a3.353,3.353,0,1,0,3.413,0V7.633Zm1.706,12.43a1.118,1.118,0,1,1,1.118-1.118A1.119,1.119,0,0,1,5.055,20.063Z" transform="translate(6140.999 2335)" class="b" /></g></svg>',
		// },
		engineLock: {
			notifications: {
				confirm: "Comando enviado correctamente.",
				error: "Ha ocurrido un error al enviar el comando.",
				errorGeneral: "Ha ocurrido un error, intente de nuevo.",
			},
		},
		group: {
			title: "Lista de grupos",
			columns: ["Nombre", "Descripción", "Dispositivos"],
			forms: {
				name: {
					label: "Nombre",
					placeholder: "Nombre",
					required: "Nombre is required",
				},
				description: {
					label: "Descripción",
					placeholder: "Descripción corta...",
				},
			},
			notifications: {
				options: { layout: 2, position: "topCenter" },
				group: {
					empty: "Nombre es requerido",
					created: "Grupo creado exitosamente",
					deleted: "El grupo fue eliminado",
					edited: "El grupo fue editado exitosamente",
				},
			},
			modals: {
				new: {
					title: "Nuevo grupo",
				},
				edit: {
					title: "Editar grupo",
				},
				delete: {
					title: "Eliminar grupo",
					message: "¿Desea eliminar el grupo {group}?",
				},
			},
		},
		mobileInfo: {
			title: "Información del móvil",
			body: {
				true: 'Si',
				false: 'No',
				platform: "Plataforma",
				versionOS: "Versión del Sistema Operativo",
				isGpsActive: "Está activado el GPS",
				isAllowedAllTime: "Está permitido todo el tiempo",
				isActiveAccessNotifications: "Está activado el acceso a notificaciones",
				isActiveFineLocation: "Está activado la buena ubicación",
				isActiveCoarseLocation: "Está activado la ubicación aproximada",
				isActiveReadWriteData: "Está activo leer y escribir información",
			}
		}
	},
};
